<template>
    <div v-if="isMercedes">
        <iframe class="mercedes-consent" :src="iframeUrl" />
    </div>
</template>

<script lang="ts">

import IManufacturer from '@/models/vehicle/interfaces/manufacturer.d';
import {
  Component, Vue
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import EnvService from '@/services/EnvironmentService';
import { PublisherService } from '@/services/PublisherService';

const PersonalDetailsModule = namespace('personalDetailsModule');

const VehicleModule = namespace('vehicleModule');

const SystemNameMappings = {
    Askaprice: 'AFF_Askaprice',
    CarKeys: 'AFF_Carkeys',
    'Green.Car': 'AFF_Greencar',
    'Van Guide': 'AFF_Vanguide'
};

@Component
export default class MercedesPostEnquiryConsentComponent extends Vue {
    @PersonalDetailsModule.Getter public personalDetails;

    @VehicleModule.Getter public currentManufacturer?: IManufacturer | null;

    get firstName() {
        return this.personalDetails.firstName;
    }

    get lastName() {
        return this.personalDetails.surname;
    }

    get email() {
        return this.personalDetails.email;
    }

    get isMercedes() {
        return this.currentManufacturer?.manufacturerId === 34
            || this.currentManufacturer?.manufacturerId === 122;
    }

    get systemName() {
        return SystemNameMappings[PublisherService.publisherName] || 'AFF_Askaprice';
    }

    get iframeUrl() {
        const baseUrl = EnvService.getEnv() === 'prod'
            ? 'https://docms.i.mercedes-benz.com/oneDoCSPA/main'
            : 'https://docms-int.i.mercedes-benz.com/oneDoCSPA/main';
        return `${baseUrl}?m=GB&l=en-GB&loc=GB&le=D-Outlet.1452815&ea=${this.email}&pnf=${this.firstName}&pnl=${this.lastName}&s=${this.systemName}`;
    }
}
</script>
